<template>
  <div class="slideshow">
    <div class="swiper-container">
      <div class="swiper-wrapper">
        <div class="swiper-slide">
          <div class="slide-l">
            <div class="box">
              <div class="sequence">
                <img alt="" src="@/assets/01.png">
              </div>
              <h2>Unimodal wearables</h2>
              <p>Long-term healthcare monitoring based on AI-empowered wearable ECG/PPG devices</p>
            </div>
            <div class="progress">
              <div class="progress-l" style="width: 120px"></div>
              <div class="progress-r"></div>
            </div>
          </div>
          <div class="slide-r">
            <div class="box_1">
              <div class="box-l">
                <div class="pic">
                  <img alt="" src="@/assets/slide_1.png">
                </div>
                <div class="pic">
                  <img alt="" src="@/assets/slide_2.png">
                </div>
              </div>
              <div class="box-r">
                <div class="pic">
                  <img alt="" src="@/assets/slide_3.png">
                </div>
                <div class="pic">
                  <img alt="" src="@/assets/slide_4.png">
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="swiper-slide">
          <div class="slide-l">
            <div class="box">
              <div class="sequence">
                <img alt="" src="@/assets/02.png">
              </div>
              <h2>Multimodal wearables</h2>
              <p>Comprehensive physiology data collection and monitoring via diverse wearable sensing technologies</p>
            </div>
            <div class="progress">
              <div class="progress-l" style="width: 240px"></div>
              <div class="progress-r"></div>
            </div>
          </div>
          <div class="slide-r">
            <div class="box_2">
              <div class="pic">
                <img alt="" src="@/assets/slide_5.png">
              </div>
            </div>
          </div>
        </div>
          <div class="swiper-slide">
              <div class="slide-l">
                <div class="box interval">
                  <div class="sequence">
                    <img alt="" src="@/assets/03.png">
                  </div>
                  <h2>Wearables for specific medical needs</h2>
                  <p>Facial monitoring for emotion estimation<br/>Human posture monitoring</p>
                </div>
                <div class="progress">
                  <div class="progress-l" style="width: 360px"></div>
                  <div class="progress-r"></div>
                </div>
              </div>
              <div class="slide-r">
                <div class="box_3">
                  <div class="box-l">
                    <div class="pic">
                      <img alt="" src="@/assets/slide_7.png">
                    </div>
                  </div>
                  <div class="box-r">
                    <div class="pic">
                      <img alt="" src="@/assets/slide_8.png">
                    </div>
                    <div class="label-list">

                      <img src="@/assets/Group796.png" >
                    </div>
                  </div>
                </div>
              </div>
          </div>
      </div>
    </div>
  </div>
</template>

<script>

  import Swiper from "swiper";

  import "swiper/dist/js/swiper";
  import "swiper/dist/css/swiper.css";
  let swiper;
  export default {
    props: {},
    data() {
      return {
        oldIndex:1,
        index: 1,
      };
    },

    components: {},
    mounted() {
      swiper = new Swiper(".swiper-container", {
        direction: "horizontal",
        loop: false,
        mousewheel: {
          releaseOnEdges: true,
        },
      });
      swiper.mousewheel.disable()
    },
    methods: {
      init(flag){
        if(flag){
          swiper.mousewheel.enable()
        }else{
          swiper.mousewheel.disable()
        }

      }
    },
  };
</script>


<style scoped>
  .slideshow {
    background-color: #fff;
    min-width: 1600px;
    height: 900px;
  }
  .swiper-container {
    width: 100%;
    height: 900px;
  }
  .swiper-wrapper {
    width: 100%;
    height: 900px;
  }
  .swiper-slide {
    width: 100%;
    height: 900px;
    box-sizing:border-box;
    padding: 0 0 75px 18vw;
    /*width: 81.25vw;*/
    display: flex;
    align-items: flex-end;
    justify-content: flex-end;
  }


  .slide-l .box .sequence {
    line-height: 0;
    width: 118px;
    height: 80px;
  }
  .slide-l .box .sequence img {
    width: 100%;
    height: 100%;
  }
  .slide-l .box h2 {
    font-weight: 700;
    font-size: 42px;
    line-height: 60px;
    color: #111111;
    margin-top: -40px;
    padding-bottom: 105px;
    width: 475px;
  }

  .slide-l .interval h2 {
    padding-bottom: 45px;
  }

  .slide-l .box p {
    font-size: 26px;
    line-height: 70px;
    color: #111111;
    min-height: 340px;
    width: 490px;
  }
  .slide-r{
    flex: 1;
  }
  .slide-r .box_1{
    width: 100%;
    height: 100%;
    display: flex;
    align-items:flex-end;
  }
  .slide-r .box_1 .box-l{
    width: 616px;
  }
  .slide-r .box_1 .box-l .pic{
    width: 100%;
    line-height: 0;
    margin-top: 30px;
  }
  .slide-r .box_1 .box-l .pic:nth-child(1) img{
    width:100%;
    height: 421px;
  }
  .slide-r .box_1 .box-l .pic:nth-child(2) img{
    width:100%;
    height: 304px;
  }
  .slide-r .box_1 .box-r{
    flex: 1;
    margin-left: 30px;
  }
  .slide-r .box_1 .box-r .pic{
    width: 100%;
    line-height: 0;
    margin-top: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #F0F3F5;
    border-radius: 12px;
  }
  .slide-r .box_1 .box-r .pic:nth-child(1){
    height: 356px;
  }
  .slide-r .box_1 .box-r .pic:nth-child(2){
    height: 304px;
  }
  .slide-r .box_1 .box-r .pic:nth-child(1) img{
    width: 266px;
    height: 260px;
  }
  .slide-r .box_1 .box-r .pic:nth-child(2) img{
    width: 146.81px;
    height: 243px;
  }
  .slide-r .box_2{
    width: 100%;
  }
  .slide-r .box_2 .pic{
    width: 100%;
    height: 665px;
    background: #F0F3F5;
    display: flex;
    justify-content: center;
    align-items: flex-end;
  }
  .slide-r .box_2 .pic img{
    width: 1060px;
    height: 756px;
  }
  .slide-r .box_3{
    width: 100%;
  }
  .slide-r .box_3 .box-l .pic{
    line-height: 0;
    width: 560px;
    height: 697px;
    background: #F0F3F5;
    border-radius: 18px;
    display: flex;
    align-items: center;
    justify-content: center;
  }


  .slide-r .box_3{
    display: flex;
    align-items: flex-end;
  }
  .slide-r .box_3 .box-l .pic img{
    width: 100%;
    height: 100%;
  }
  .slide-r .box_3 .box-r{
    flex: 1;
    margin-left: 30px;
  }
  .slide-r .box_3 .box-r .pic{
    width: 100%;
    line-height: 0;
    border-radius: 18px;
    display: flex;
    align-items: center;
  }
  .slide-r .box_3 .box-r .pic img{
    width: 470px;
    height: 412px;
  }
  .slide-r .box_3 .box-r .label-list{
    margin-top: 30px;
  }

  .slide-r .box_3 .box-r .label-list img {
    width: 470px;
  }

  .progress {
    width: 360px;
    height: 2px;
    display: flex;
    align-items: center;
  }

  .progress .progress-l {
    background-color: #000;
    height: 2px;
    transition: 1s;
  }

  .progress .progress-r {
    flex: 1;
    height: 2px;
    background: linear-gradient(to right, #A3DBEE, #CD7482);
  }


</style>
